var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2929 28.2929C39.9024 28.6834 39.9024 29.3166 40.2929 29.7071C40.6834 30.0976 41.3166 30.0976 41.7071 29.7071L46.7071 24.7071C47.0976 24.3166 47.0976 23.6834 46.7071 23.2929L41.7071 18.2929C41.3166 17.9024 40.6834 17.9024 40.2929 18.2929C39.9024 18.6834 39.9024 19.3166 40.2929 19.7071L43.5858 23H26C25.4477 23 25 23.4477 25 24C25 24.5523 25.4477 25 26 25H43.5858L40.2929 28.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.df148103e0c1e7c67880dcb513956328.svg";
export { ForwardRef as ReactComponent };